module.exports = __webpack_public_path__ + "static/media/zoomin.9ddf0984.png";